module.exports = __webpack_public_path__ + "img/IMG_9033_FoamcoreMatted.38b0387b.jpg";